import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.GlobalCommandOrgCategoriesForm'

export default defineMessages({
  primaryCategoryLabel: {
    id: `${scope}.primaryCategoryLabel`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel}',
  },
  primaryCategoryPlaceholder: {
    id: `${scope}.primaryCategoryPlaceholder`,
    defaultMessage: 'Select a {singularPrimaryOrgCategoryLabel}',
  },
  primaryCategoryRequired: {
    id: `${scope}.primaryCategoryRequired`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel} is required',
  },
  secondaryCategoryLabel: {
    id: `${scope}.secondaryCategoryLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  secondaryCategoryPlaceholder: {
    id: `${scope}.secondaryCategoryPlaceholder`,
    defaultMessage: 'Select a {singularSecondaryOrgCategoryLabel}',
  },
  secondaryCategoryRequired: {
    id: `${scope}.secondaryCategoryRequired`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel} is required',
  },
  agentLabelPlaceholder: {
    id: `${scope}.agentLabelPlaceholder`,
    defaultMessage: 'Select a {label}',
  },
  agentLabelRequired: {
    id: `${scope}.agentLabelRequired`,
    defaultMessage: '{label} is required',
  },
  cancelButtonText: {
    id: `${scope}.cancelButtonText`,
    defaultMessage: 'Cancel',
  },
  saveButtonText: {
    id: `${scope}.saveButtonText`,
    defaultMessage: 'Save changes',
  },
})
